import api from "./api";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const pageSize = 15;

export async function fetchCpfHistory(
    pageNumber: number,
    filters: any
): Promise<any> {
    const params: any = {
        page: pageNumber,
        pageSize,
        protocol: filters.protocol || null,
        document: filters.document || null,       // CPF
        startDate: filters.startDate || null,
        endDate: filters.endDate || null,
        status: filters.status || null,
        deviceId: filters.deviceId || null,
        geoLocalizacao: filters.geoLocalizacao || null,
        ip: filters.ip || null,
        deviceIp: filters.deviceIp || null,
    };

    const response = await api.get("/ConsultationCpfLog/paged", { params });
    return response;
}

export async function concluirConsultaCpf(protocol: string): Promise<void> {
    await api.put(`/ConsultationCpfLog/AlterStatus?protocol=${protocol}`);
}

export async function alterarStatusCpf(
    protocol: string,
    newStatus: number,
    notes?: string
): Promise<void> {
    const baseURL = process.env.REACT_APP_API_URL!;
    const raw = localStorage.getItem("token") || "";
    const tk: any = raw ? jwtDecode(raw) : {};

    console.log("tk", tk);

    const payload = {
        protocol,
        newStatus,
        notes,
        changedByUserId: tk?.UserId ?? tk?.sub ?? null,
        changedByName: tk?.unique_name ?? tk?.name ?? null,
        changedByEmail: tk?.Email ?? tk?.email ?? null,
        appKey: tk?.Appkey ?? null,
    };

    await axios.put(`${baseURL}/ConsultationCpfLog/AlterStatus`, payload, {
        headers: { "Content-Type": "application/json" },
    });
}


// novo: busca logs
export interface IStatusChangeLog {
    id: number;
    protocol: string;
    oldStatus: number;
    newStatus: number;
    changedByUserId?: string;
    changedByName?: string;
    changedByEmail?: string;
    clientIp?: string;
    notes?: string;
    changedAt: string; // ISO
}

export async function fetchCpfStatusChanges(protocol: string, from?: string, to?: string) {
    const params: any = { protocol };
    if (from) params.from = from;
    if (to) params.to = to;
    const { data } = await api.get("/ConsultationCpfLog/status-changes", { params });
    return data as IStatusChangeLog[];
}